import React from 'react';
import { Award, CheckCircle, MapPin, Activity } from 'lucide-react';
import { trustBar } from '../data/mock';

const TrustBar = () => {
  const icons = [Award, CheckCircle, MapPin, Activity];

  return (
    <section className="py-12 bg-white border-y border-gray-100">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {trustBar.stats.map((stat, index) => {
            const IconComponent = icons[index];
            return (
              <div key={index} className="text-center group">
                <div className="flex justify-center mb-4">
                  <div className="bg-gradient-to-br from-[#20B2AA]/10 to-[#E63946]/10 p-4 rounded-2xl group-hover:from-[#E63946] group-hover:to-[#D32F3D] transition-all duration-300">
                    <IconComponent className="h-8 w-8 text-[#1B1B3A] group-hover:text-white transition-colors" />
                  </div>
                </div>
                <div className="text-4xl font-bold text-[#E63946] mb-2">
                  {stat.number}
                </div>
                <div className="text-sm text-gray-600 font-medium">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
